import imageCompression from "browser-image-compression";

export default function useFileCompression() {
    const compressFile = async (file) => {
        switch (file.type) {
            case 'image/jpeg':
            case 'image/png':
            case 'image/gif':
            case 'image/webp':
                return await compressImage(file);
            case 'application/pdf':
                return await compressPDF(file);
            default:
                return "Type de fichier non pris en charge. Types acceptés: image/jpeg, image/png, image/gif, image/webp, application/pdf";
        }
    };

    const compressImage = async (file) => {
        try {
            const options = {
                maxSizeMB: 2,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            };

            return  await imageCompression(file, options);
        } catch (error) {
            console.error("Erreur lors de la compression de l'image:", error);
        }
    };

    const compressPDF = async (file) => {
        try {
            const options = {
                maxSizeMB: 2,
            };

            return file;
        } catch (error) {
            console.error("Erreur lors de la compression du PDF:", error);
        }
    }

    return { compressFile, compressImage, compressPDF };
}
